import { CONTACT_PHONES, phoneHref } from '../utils/contactPhones';
import '../styles/components/ContactPhones.scss';

/** Teléfonos de contacto en cuadrícula de 2 columnas. Lo usan el header y el footer. */
const ContactPhones = ({ className = '' }) => (
  <div className={`ContactPhones ${className}`.trim()}>
    {CONTACT_PHONES.map((phone) => (
      <a key={phone} href={phoneHref(phone)}>{phone}</a>
    ))}
  </div>
);

export default ContactPhones;
